// export const StorybookInputGroupArgs = {};

export const StorybookInputGroupArgs = {
  backgroundColor: {
    name: "backgroundColor",
    type: { name: "string", required: true },
    defaultValue: "primary",
    options: ["primary.500", "blue.500"],
    control: {
      type: "select",
    },
  },
  iconBackground: {
    name: "iconBackground",
    type: { name: "string", required: true },
    defaultValue: "primary",
    options: ["primary.500", "blue.500"],
    control: {
      type: "select",
    },
  },
  variant: {
    name: "variant",
    type: { name: "string", required: true },
    defaultValue: "unstyled",
    options: ["filled", "outline", "unstyled"],
    control: {
      type: "radio",
    },
  },

  isHovered: {
    name: "isHovered",
    type: { name: "boolean" },
    defaultValue: false,

    control: {
      type: "boolean",
    },
  },
};
